// extracted by mini-css-extract-plugin
export default {"Container":"PatternsPage_Container__gEvE3","Controls":"PatternsPage_Controls__PUPqv","CardLink":"PatternsPage_CardLink__n-ZQy"};